import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../context/NotificationContext';
import { notificationModel } from '../../data/notificationModel';
import NotificationItem from './NotificationItem';

const NotificationList = ({ onClose }) => {
  const { t } = useTranslation();
  const { notifications, loading, markAllAsRead } = useNotification();
  
  // Calculate unread count from notifications array (more reliable)
  const unreadNotifications = notifications.filter(n => !n.read);
  const unreadCount = unreadNotifications.length;
  
  const handleMarkAllAsRead = async (e) => {
    // Prevent event propagation to avoid closing dropdown
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    try {
      console.log('[NotificationList] Marking all as read, current unread count:', unreadCount);
      await markAllAsRead();
      console.log('[NotificationList] Mark all as read completed');
      // Don't close dropdown - let user see the updated state
    } catch (error) {
      console.error('[NotificationList] Error marking all as read:', error);
      alert('เกิดข้อผิดพลาดในการทำเครื่องหมายว่าอ่านแล้วทั้งหมด');
    }
  };

  if (loading) {
    return (
      <div className="p-4 text-center">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-500 mx-auto"></div>
        <p className="text-sm text-gray-600 mt-2">{t('common.loading')}</p>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="p-8 text-center">
        <div className="text-gray-400 text-4xl mb-2">🔔</div>
        <p className="text-gray-600">{t('notifications.noNotifications')}</p>
      </div>
    );
  }

  const readNotifications = notifications.filter(n => n.read);

  return (
    <div>
      {unreadNotifications.length > 0 && (
        <div>
          <div 
            className="px-3 sm:px-4 py-2 sm:py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between sticky top-0 z-10"
            onMouseDown={(e) => {
              // Prevent parent from intercepting clicks on this header
              e.stopPropagation();
            }}
          >
            <span className="text-sm sm:text-base font-semibold text-gray-700">{t('notifications.new')}</span>
            {unreadNotifications.length > 0 && (
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('[NotificationList] Button clicked!');
                  handleMarkAllAsRead(e);
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className="text-xs sm:text-sm text-green-600 hover:text-green-700 active:text-green-800 px-2 py-1 rounded transition-colors cursor-pointer relative z-20"
                style={{ pointerEvents: 'auto' }}
              >
                {t('notifications.markAllRead')}
              </button>
            )}
          </div>
          {unreadNotifications.map((notification) => (
            <NotificationItem key={notification.id} notification={notification} onClose={onClose} />
          ))}
        </div>
      )}

      {readNotifications.length > 0 && (
        <div>
          {unreadNotifications.length > 0 && (
            <div className="px-3 sm:px-4 py-2 sm:py-3 bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
              <span className="text-sm sm:text-base font-semibold text-gray-700">{t('notifications.read')}</span>
            </div>
          )}
          {readNotifications.map((notification) => (
            <NotificationItem key={notification.id} notification={notification} onClose={onClose} />
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationList;


